/* unplugin-vue-components disabled */import script from "./AnimateText.vue?vue&type=script&lang=ts&setup=true"
export * from "./AnimateText.vue?vue&type=script&lang=ts&setup=true"

import "./AnimateText.vue?vue&type=style&index=0&id=38d55a3a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38d55a3a"]])

export default __exports__